import { useTranslation } from 'react-i18next'

import { SelectOption } from 'components/Select'
import {
  ScrollSlowingIntensity,
  scrollSlowingIntensity,
} from 'features/inventory/domain/types/ScrollSlowingIntensity'

export const useScrollSlowingIntensityOptions = (): SelectOption<ScrollSlowingIntensity>[] => {
  const { t } = useTranslation('features/domain')

  return scrollSlowingIntensity.map(
    (level: ScrollSlowingIntensity): SelectOption<ScrollSlowingIntensity> => ({
      label: t(
        `form.viewabilityTools.basicSettings.scrollSlowingEnabled.scrollSlowingIntensity.options.${level}`,
      ),
      value: level,
    }),
  )
}
